import { useState } from 'react'
import { Button } from '@mui/material'

import { ImpactsLibraryModal } from './impacts-library-modal.component'
import { useStyles } from './styles'
import { HelperWrapper } from 'src/components/helper-wrapper'

const ImpactsLibraryButton = () => {
  const [open, setOpen] = useState(false)
  const classes = useStyles()

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  return (
    <>
      <Button
        type="button"
        onClick={handleOpen}
        variant="contained"
        color="secondary"
        className={`${classes.impactsLibraryButton} ${classes.buttonMb}`}
      >
        <HelperWrapper t="impacts-library-search-db" isColorInherited />
      </Button>
      <ImpactsLibraryModal handleClose={handleClose} open={open} />
    </>
  )
}

export { ImpactsLibraryButton }
